var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-container"},[_c('div',{staticClass:"assets"}),_c('div',{staticClass:"wrap-content"},[_c('div',{staticClass:"logo"})])])}]

export { render, staticRenderFns }